import { useEffect, useState } from "react";
import styles from '../JobApplications/CandidateApplicationConditionalQuestionnaire.module.css'

const questions = [{
    id: 1, text: "Have you contacted the candidate for this job?", options: [{ text: "Yes", nextQuestion: 2, },],
},
{
    id: 2,
    text: "Did you had the conversation with the candidate?",
    options: [
        {
            text: "Yes",
            nextQuestion: 4,
        },
        {
            text: "No",
            nextQuestion: 3,
        },
    ],
},
{
    id: 3,
    text: "Why could you not have the conversation with the candidate?",
    options: [
        { text: "Busy on Another Call", nextQuestion: 6, hintText: "" },
        { text: "Call disconnected", nextQuestion: 6, hintText: "Choose this only when you hear beep without being picked up by the candidate" },
        { text: "Call dropped in between", nextQuestion: 6, hintText: "" },
        { text: "Candidate is Busy", nextQuestion: 6, hintText: "" },
        { text: "Did not pick the call", nextQuestion: 6, hintText: "" },
        { text: "Hanging Up the call", nextQuestion: 6, hintText: "Choose this when phone is ringing and person is disconnecting the call" },
        { text: "Invalid Number", nextQuestion: 6, hintText: "" },
        { text: "No Incoming Available", nextQuestion: 6, hintText: "Choose this when candidate's recharge is over" },
        { text: "Out of Reach", nextQuestion: 6, hintText: "Choose this when number is out of reach, out of coverage, out of range" },
        { text: "Someone else picked", nextQuestion: 6, hintText: "" },
        { text: "Switch Off", nextQuestion: 6, hintText: "" },
        { text: "Wrong number", nextQuestion: 6, hintText: "" },
        { text: "Wrong Person Number", nextQuestion: 6, hintText: "Choose this when person said wrong number" }
    ],
},
{
    id: 4,
    text: "Are you considering the candidate for this job?",
    options: [
        {
            text: "Yes",
            nextQuestion: 6,
        },
        {
            text: "No",
            nextQuestion: 5,
        },
    ],
},
{
    id: 5,
    text: "Why are you not considering the candidate for this job?",
    // options: [
    //     { text: "Not interested in job role", hintText : "" },
    //     { text: "Salary expectations not met", hintText : "" },
    //     { text: "Location not suitable", hintText : "" },
    //     { text: "Better opportunity elsewhere", hintText : "" },
    //     { text: "Lack of required skills", hintText : "" },
    //     { text: "Personal reasons", hintText : "" },
    //     { text: "Other commitments", hintText : "" },
    //     { text: "Unavailability", hintText : "" },
    //     { text: "Not a good fit for company culture", hintText : "" },
    //     { text: "Health issues", hintText : "" },
    //     { text: "Family reasons", hintText : "" },
    //     { text: "Relocation issues", hintText : "" },
    //     { text: "Career change", hintText : "" },
    // ],
},
{
    id: 6,
    text: "Thank you for your response.",
    options: [],
},
];

const CandidateApplicationConditionalQuestionnaire = props => {
    const { activeCandidate, jobIdentifier, updateApplicationCreationActivity } = props
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [answers, setAnswers] = useState([]);

    useEffect(() => {
        if (activeCandidate !== null) {
            setCurrentQuestionIndex(0)
            setAnswers([])
        }
    }, [activeCandidate, jobIdentifier])


    const currentQuestion = questions[currentQuestionIndex];
    const [reason, setReason] = useState('')

    const breadcrumbItems = questions
        .filter((item) => item.id <= currentQuestion.id)
        .map((item) => ({ id: item.id, text: item.text }));

    const handleAnswerClick = (answer) => {
        const newAnswer = { question: currentQuestion, answer };

        if (currentQuestion.text === "Have you contacted the candidate for this job?") {
            updateApplicationCreationActivity("CONTACTED", "Executive tried contacted the stylist for this profile.")
        } else if (currentQuestion.text === "Did you had the conversation with the candidate?") {
            if (answer.text === "Yes") {
                updateApplicationCreationActivity("HAD_CONVERSATION", "Executive had a conversation with the candidate.")
            }
        } else if (currentQuestion.text === "Why could you not have the conversation with the candidate?") {
            updateApplicationCreationActivity("COULD_NOT_HAD_CONVERSATION", answer.text)
        } else if (currentQuestion.text === "Are you considering the candidate for this job?") {
            if (answer.text === "Yes") {
                updateApplicationCreationActivity("PROFILE_CONSIDERED", "Candidate profile considered for this job.")
            }
        } else if (currentQuestion.text === "Why are you not considering the candidate for this job?") {
            updateApplicationCreationActivity("PROFILE_NOT_CONSIDERED", answer.text)
        }

        const updatedAnswers = [...answers];
        const existingAnswerIndex = updatedAnswers.findIndex(
            (answer) => answer.question.id === currentQuestion.id
        );
        if (existingAnswerIndex >= 0) {
            updatedAnswers[existingAnswerIndex] = newAnswer;
        } else {
            updatedAnswers.push(newAnswer);
        }
        setAnswers(updatedAnswers);
        if (answer.nextQuestion) {
            setCurrentQuestionIndex(answer.nextQuestion - 1);
        } else {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
        }
    };

    const handleBreadcrumbClick = (questionId) => {
        setCurrentQuestionIndex(questionId - 1);
    };

    const handleTextareaSubmit = () => {
        handleAnswerClick({ text: reason });
    };


    return (
        <div className={styles.mainWrapper}>
            <div className={styles.breadCrumbWrapper}>
                {breadcrumbItems.map((item, index) => (
                    <div key={item.id}>
                        {index !== breadcrumbItems.length - 1 ? (
                            <button onClick={() => handleBreadcrumbClick(item.id)} className={styles.navBtn}>
                                {item.id}
                            </button>
                        ) : (
                            <span className={styles.navBtnDis}>{item.id}</span>
                        )}
                    </div>
                ))}
            </div>

            <div className={styles.questionsWrapper}>
                <div className={styles.question}>{currentQuestion.text}</div>
                {currentQuestion.options ? (
                    <div className={currentQuestion.options?.length > 2 ? styles.answersOptionWrapperCol : styles.answersOptionWrapperRow}>
                        {currentQuestion.options.map((option, index) => (
                            <div key={index} title={option.hintText ? option.hintText : ""} className={styles.optionBtnWrapper} >
                                <button onClick={() => handleAnswerClick(option)}
                                    className={styles.optionBtn}
                                >
                                    {option.text}
                                    <div className={styles.hintTextWrapper}>
                                        {option?.hintText && <span className={styles.hintText}>{option?.hintText}</span>}
                                    </div>
                                </button>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div>
                        <textarea name="answer" rows="4" cols="50" onChange={(e) => setReason(e.target.value)} />
                        <br />
                        <button onClick={() => handleTextareaSubmit()} >Submit</button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CandidateApplicationConditionalQuestionnaire;
